<fieldset>
 <legend>
  TypeNatureMarcheLot
 </legend>
 <app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="natureMarche.fournitures" 
 
[label]="'fournitures'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_fournitures'">
</app-form-input>

<!---->

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="natureMarche.travaux" 
 
[label]="'travaux'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_travaux'">
</app-form-input>

<!---->

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="natureMarche.services" 
 
[label]="'services'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_services'">
</app-form-input>
</fieldset>